import React from "react"
import { Link } from "@zestia/gatsby-plugin-react-i18next"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const FeatureHeroWithTestimonial = ({
  kicker,
  title,
  description,
  buttonText,
  buttonLink,
  productImage,
  testimonial,
}) => {
  return (
    <section className="feature-hero-with-testimonial container-fluid">
      <div className="divider--dashed divider--dashed--1240"></div>
      <div className="row feature-hero-with-testimonial__header">
        <div className="col-xs-12 col-md-9">
          {kicker && <span className="heading-kicker">{kicker}</span>}

          {title && <h2>{title}</h2>}

          {description && <p className="p--lg col-md-8">{description}</p>}
        </div>

        {buttonText && buttonLink && (
          <Link
            to={buttonLink}
            className="btn btn--lg feature-hero-with-testimonial__cta"
          >
            {buttonText}
          </Link>
        )}
      </div>

      <div className="center-xs feature-hero-with-testimonial__images">
        <div className="feature-hero-with-testimonial__product-image">
          {productImage && (
            <GatsbyImage
              className="feature-hero-with-testimonial__image"
              image={getImage(productImage.src)}
              alt={productImage.alt}
            />
          )}
        </div>

        <div className="feature-hero-with-testimonial__testimonial-image">
          {testimonial.image && (
            <GatsbyImage
              className="feature-hero-with-testimonial__image"
              image={getImage(testimonial.image.src)}
              alt={testimonial.image.alt}
            />
          )}

          {testimonial && (
            <blockquote className="feature-hero-with-testimonial__testimonial">
              {testimonial.logo && (
                <>
                  {typeof testimonial.logo === "function" ? (
                    <testimonial.logo
                      className={`feature-hero-with-testimonial__logo ${
                        testimonial.logoClassName || ""
                      }`}
                      alt={testimonial.logoAlt}
                      width={testimonial.logoWidth}
                      height={testimonial.logoHeight}
                    />
                  ) : testimonial.logo.src ? (
                    <GatsbyImage
                      className="feature-hero-with-testimonial__logo"
                      image={getImage(testimonial.logo.src)}
                      alt={testimonial.logo.alt}
                    />
                  ) : null}
                </>
              )}
              <div className="feature-hero-with-testimonial__testimonial-content">
                <p className="feature-hero-with-testimonial__quote">
                  "{testimonial.quote}"
                </p>

                <cite className="feature-hero-with-testimonial__attribution">
                  <p className="feature-hero-with-testimonial__attribution-name">
                    {testimonial.name}
                  </p>
                  {testimonial.role && (
                    <p className="feature-hero-with-testimonial__attribution-role p--sm">
                      {testimonial.role}
                    </p>
                  )}
                </cite>
              </div>
            </blockquote>
          )}
        </div>
      </div>
    </section>
  )
}

export default FeatureHeroWithTestimonial
